// utils
import { makeApiCall, makeDownstreamApiCall, unwrapResponseWithCode } from "@payment-client/utils/Api";

// interfaces
import {
    JuspayCardFingerprint,
    JuspayClientAuthTokenData,
    GetCardFingerprintParams,
} from "@payment-client/interfaces/Juspay";
import {
    JUSPAY_API_HOST,
    JUSPAY_ENDPOINTS,
    JUSPAY_CARD_FINGERPRINT_API_TIMEOUT,
} from "@payment-client/constants/Juspay";

export const ENDPOINT = {
    GET_JUSPAY_CLIENT_AUTH_TOKEN: "/api/v1/juspay/get-client-auth-token",
};

export interface GetAuthTokenParams {
    apiHost: string;
    tenant: string;
}

export async function getJuspayClientAuthToken(params: GetAuthTokenParams): Promise<JuspayClientAuthTokenData> {
    const { apiHost, tenant } = params;
    const response = unwrapResponseWithCode(
        await makeApiCall<JuspayClientAuthTokenData>({
            apiHost,
            endpoint: ENDPOINT.GET_JUSPAY_CLIENT_AUTH_TOKEN,
            options: {
                headers: {
                    tenant,
                },
            },
        }),
    );

    return response.toPromise();
}

export async function fetchCardFingerprint({
    cardNumber,
    userId,
    merchantId = "",
    authToken = "",
}: GetCardFingerprintParams): Promise<JuspayCardFingerprint | null> {
    return makeDownstreamApiCall<JuspayCardFingerprint>({
        apiHost: JUSPAY_API_HOST,
        endpoint: JUSPAY_ENDPOINTS.FINGERPRINT,
        bodyParams: {
            /* eslint-disable @typescript-eslint/naming-convention */
            card_number: cardNumber,
            client_auth_token: authToken,
            customer_id: String(userId),
            /* eslint-enable @typescript-eslint/naming-convention */
        },
        options: {
            method: "POST",
            headers: {
                "x-merchantid": merchantId,
                "Content-Type": "application/json",
            },
        },
        retry: false,
        timeout: JUSPAY_CARD_FINGERPRINT_API_TIMEOUT,
        excludeDefaultHeaders: true,
    });
}
